import React from 'react';
import ReactDOM from 'react-dom';
import App from 'pages/App';
import Amplify from 'aws-amplify';

Amplify.configure({
  Auth: {
    region: import.meta.env.VITE_APP_AMPLIFY_REGION,
    userPoolId: import.meta.env.VITE_APP_AMPLIFY_USER_POOL_ID,
    userPoolWebClientId: import.meta.env
      .VITE_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  },
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
